module.exports = __webpack_public_path__ + "img/RIAAN.176c6150.webp";